<template>
  <div class="ui-state" :role="kind === 'error' ? 'alert' : 'status'" :aria-busy="kind === 'loading' ? 'true' : null">
    <template v-if="kind === 'loading'">
      <div v-if="tiles" class="ui-kpis">
        <div v-for="n in tiles" :key="n" class="ui-kpi" style="cursor: default">
          <span class="ui-sk" style="width: 50%; height: 11px"></span>
          <span class="ui-sk" style="width: 40%; height: 22px"></span>
        </div>
      </div>
      <div class="ui-card">
        <div v-for="n in rows" :key="`r${n}`" class="ui-skel-row">
          <span class="ui-sk" style="width: 34px; height: 34px; border-radius: 50%"></span>
          <span style="flex: 1; display: grid; gap: 6px">
            <span class="ui-sk" style="width: 40%; height: 12px"></span>
            <span class="ui-sk" style="width: 25%; height: 10px"></span>
          </span>
          <span class="ui-sk" style="width: 90px; height: 22px"></span>
        </div>
      </div>
    </template>
    <div v-else class="ui-card">
      <div class="ui-empty" :class="[lg && 'ui-empty--lg', tight && 'ui-empty--tight']">
        <span class="ui-empty__icon"><v-icon size="22">{{ icon }}</v-icon></span>
        <b>{{ title }}</b>
        <span v-if="text">{{ text }}</span>
        <div class="ui-empty__actions"><slot></slot></div>
      </div>
    </div>
  </div>
</template>

<script>
/** Stanja ekrana: učitavanje (skelet), greška, prazno. kind: loading | error | empty; dugme se daje kroz slot. */
export default {
  name: "UiState",
  props: {
    kind: { type: String, default: "empty" },
    icon: { type: String, default: "mdi-tray-full" },
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    /** koliko pločica brojki skelet crta (0 = bez) */
    tiles: { type: Number, default: 4 },
    rows: { type: Number, default: 6 },
    /** prazno stanje cijelog ekrana ili panela (veće); tight smanjuje razmake */
    lg: { type: Boolean, default: false },
    tight: { type: Boolean, default: false },
  },
};
</script>
